import heic2any from 'heic2any';

/** Safari 17+ converts JPEG/PNG to HEIC when image/heic is in accept — omit it on Safari. */
export function isSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android/i.test(ua);
}

export const IMAGE_ACCEPT_SAFARI = 'image/*';
export const IMAGE_ACCEPT_DEFAULT = 'image/*,.heic,.heif,image/heic,image/heif';

export function getImageInputAccept() {
  return isSafari() ? IMAGE_ACCEPT_SAFARI : IMAGE_ACCEPT_DEFAULT;
}

export function isHeicFile(file) {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  return (
    type === 'image/heic' ||
    type === 'image/heif' ||
    type === 'image/heic-sequence' ||
    type === 'image/heif-sequence' ||
    name.endsWith('.heic') ||
    name.endsWith('.heif')
  );
}

/**
 * Normalize iPhone/Safari uploads for preview, crop, and export.
 * Safari decodes HEIC natively; other browsers need heic2any.
 */
export async function ensureBrowserCompatibleImage(file) {
  if (!file) {
    return file;
  }

  // Safari handles HEIC in img/canvas; heic2any is heavy and unreliable on iOS.
  if (isSafari()) {
    return file;
  }

  if (!isHeicFile(file)) {
    return file;
  }

  const converted = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.92,
  });
  const blob = Array.isArray(converted) ? converted[0] : converted;
  const baseName = (file.name || 'image').replace(/\.(heic|heif)$/i, '') || 'image';
  return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
}
